import React, { createContext, useContext } from 'react';
import { useAuth } from './AuthContext';

type SubscriptionContextType = {
  hasActiveSubscription: () => boolean;
};

const SubscriptionContext = createContext<SubscriptionContextType | undefined>(undefined);

export function SubscriptionProvider({ children }: { children: React.ReactNode }) {
  const { user } = useAuth();

  const hasActiveSubscription = (): boolean => {
    if (!user) return false;
    return user.has_access === true;
  };

  return (
    <SubscriptionContext.Provider value={{ hasActiveSubscription }}>
      {children}
    </SubscriptionContext.Provider>
  );
}

export function useSubscription() {
  const context = useContext(SubscriptionContext);
  if (context === undefined) {
    throw new Error('useSubscription must be used within a SubscriptionProvider');
  }
  return context;
}